<template>
    <div
        class="relative inline-flex -mr-1 align-text-bottom items-center font-normal"
    >
        <div @mouseenter="show = true" @mouseleave="show = false">
            <QuestionMarkCircleIcon class="w-5 h-5 text-gray-400" />
        </div>
        <transition
            enter-active-class="duration-200 ease-out z-10"
            enter-from-class="opacity-0 scale-95 z-10"
            enter-to-class="opacity-100 scale-100 z-10"
            leave-active-class="duration-100 ease-in z-10"
            leave-from-class="opacity-100 scale-100 z-10"
            leave-to-class="opacity-0 scale-95 z-10"
        >
            <div
                v-if="show"
                class="absolute bottom-full -ml-4 -mr-20 sm:-mx-12 flex flex-col items-center mb-1"
            >
                <span
                    class="relative z-10 p-2 text-xs text-white whitespace-no-wrap bg-gray-800 rounded shadow-lg"
                    >{{ message }}</span
                >
                <div
                    class="relative -left-8 sm:left-0 w-3 h-3 -mt-2 rotate-45 bg-gray-800 z-20"
                ></div>
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { QuestionMarkCircleIcon } from "@heroicons/vue/solid";

defineProps<{
    message?: string;
}>();

const show = ref(false);
</script>
